/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import ShareModal from '../../reusable/ShareModal';
import ShareIcon from '../../svgIcons/ShareIcon';
import { UserApi } from '../../../services';
import { notifyWarn } from '../../../utils/helpers';

const ShareProfile = ({
    Label,
    header,
    title,
    url,
    id,
    color,
    profile,
    isHiddenLabel = false
}) => {
    const navigate = useNavigate();

    const createProfileShareToken = async () => {
        try {
            const response = await UserApi.createProfileShareToken({
                userId: profile.id
            });
            return response?.data?.data?.token;
        } catch (error) {
            notifyWarn(
                error.response.data.message || 'Could not create shareable link'
            );
        }
    };

    return (
        <div className='flex items-center justify-end col-start-3'>
            <ShareModal id={id} header={header} title={title} url={url} />
            {Label ? (
                <Label />
            ) : (
                <label
                    // htmlFor={id}
                    onClick={async () => {
                        // Skip token creation if profile sharing is private
                        const isPrivate =
                            profile?.profileShareStatus === 'private';
                        const token = !isPrivate
                            ? await createProfileShareToken()
                            : null;
                        const urlToShare = token
                            ? url.includes('shareToken=')
                                ? url.replace(
                                      /shareToken=[^&]*/,
                                      `shareToken=${encodeURIComponent(token)}`
                                  )
                                : url +
                                  '&shareToken=' +
                                  encodeURIComponent(token)
                            : url;

                        const stateData = {
                            type: 'profile',
                            profile,
                            url: urlToShare,
                            title
                        };
                        navigate('/feed/share', {
                            state: stateData
                        });
                    }}
                    className={
                        'mr-4 rounded-full cursor-pointer' +
                        (isHiddenLabel ? ' hidden' : '') // Hide label if the current profile is being viewed via a share token
                    }
                >
                    {/* <img
            src="/images/shareIcon.svg"
            alt="profile picture"
            className="object-cover w-full h-full"
          /> */}
                    <div className='object-cover w-full h-full'>
                        <ShareIcon fill={color} />
                    </div>
                </label>
            )}
        </div>
    );
};

export default memo(ShareProfile);
